/** A labelled value in a definition list (`<dt>`/`<dd>`). */
export function Fact(props: { label: string; value: string }) {
  return (
    <div>
      <dt>{props.label}</dt>
      <dd>{props.value}</dd>
    </div>
  );
}
